import React, { useState, useEffect, useRef } from "react";
import { FaCircleInfo } from "react-icons/fa6";
import "./ECommerce.css";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
import { Url } from "../../Services/Api";
import { FaFileCsv } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import CustomBtnLogo from "../../Components/UI-Controls/Buttons/BtnLogo";
import swapicon from "../../Assets/Images/swap.png"
import { TbFileDownload } from "react-icons/tb";
import axios from "axios";
import BottomToust from "../../Components/BottomToust/BottomToust";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";


export default function WpProductChecking() {
    const [payMethodsOptions, setPayMethodsOptions] = useState([]);
    const [categories, setCategories] = useState([]);
    const [csvFile, setCsvFile] = useState(null);
    const [csvContent, setCsvContent] = useState("");
    const fileInputRef = useRef(null);
    const [loading,setLoading] = useState(false);

    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };


    /* --- Function to Get Categories via API Call and Update State By Using Hook --- */
    const fetchCategories = async () => {
        try {
            const response = await fetch(
                `${Url}/api/v1/productCategory/get`
            );
            const data = await response.json();

            if (!data || !data.categories) {
                console.error("No categories found in the response data");
                return;
            }

            const mainCategories = [];
            const subCategories = {};

            data.categories.forEach((category) => {
                if (category.parent === 0) {
                    mainCategories.push({
                        ...category,
                        subcategories: [],
                    });
                } else {
                    if (!subCategories[category.parent]) {
                        subCategories[category.parent] = [];
                    }
                    subCategories[category.parent].push(category);
                }
            });

            mainCategories.forEach((mainCategory) => {
                if (subCategories[mainCategory.uid]) {
                    mainCategory.subcategories = subCategories[mainCategory.uid];
                }
            });

            setCategories(mainCategories);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const [selectedCategory, setSelectedCategory] = useState(null);

    const renderSubcategories = (category) => {
        if (!category.subcategories || category.subcategories.length === 0)
            return null;

        return (
            <div className="subcategory-list">
                {category.subcategories.map((subcategory) => (
                    <div className="subcategory-item" key={subcategory.uid}>
                        <input
                            type="checkbox"
                            disabled={false}
                            id={`subcategory-${subcategory.uid}`}
                            checked={selectedCategory?.uid === subcategory.uid}
                            onChange={() => {
                                setSelectedCategory(subcategory);
                            }}

                            className="AddCheckedBoxes"
                        />
                        <label htmlFor={`subcategory-${subcategory.uid}`}>{subcategory.name}</label>
                    </div>
                ))}
            </div>
        );
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file && file.type === "text/csv") {
            setCsvFile(file);

            const reader = new FileReader();
            reader.onload = function (event) {
                setCsvContent(event.target.result); // Store CSV content
            };
            reader.readAsText(file); // ✅ only call this once!
        } else {
            alert("Please upload a valid CSV file.");
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const [resultStats, setResultStats] = useState({
        variations: 0,
        simple: 0,
        react_total: 0,
        wp_total: 0
    })

    const [variationsArray, setVariationsArray] = useState([]);
    const [simpleArray, setSimpleArray] = useState([]);


    const convertToCSV = (array) => {
        if (!array || !array.length) return null;

        const header = Object.keys(array[0]).join(",");
        const rows = array.map((row) =>
            Object.values(row)
                .map((value) =>
                    typeof value === "string" && value.includes(",")
                        ? `"${value}"`
                        : value
                )
                .join(",")
        );

        return [header, ...rows].join("\n");
    };

    const handleExport = async (data, type, name) => {
        try {
            const dataToExport = data; // Use your actual array here

            const csv = convertToCSV(dataToExport);

            if (!csv) throw new Error("No data to export");

            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${name}_${type}_products.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setToastMessage("Data has been exported successfully!");
            setShowMessage(true);
        } catch (error) {
            console.error(error);
            setToastMessage("Something went wrong. Kindly check it carefully.");
            setShowMessage(true);
        }
    };




    const handleCompareProducts = async () => {
        if (!selectedCategory) {
            alert("Please select a category.");
            return;
        }

        if (!csvFile) {
            alert("Please upload a CSV file.");
            return;
        }

        try {
            setLoading(true)
            const formData = new FormData();
            formData.append("uid", selectedCategory.uid);
            formData.append("file", csvFile);

            const response = await axios.post(`https://recommendations.myfurnituremecca.com/match-wp-csv`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            console.log("Response:", response.data);
            setResultStats({
                variations: response.data?.info?.variations,
                simple: response.data?.info?.simple,
                react_total: response.data?.info?.react_total,
                wp_total: response.data?.info?.wp_total,
            });
            setSimpleArray(response.data?.simple_df);
            setVariationsArray(response.data?.variation_df);
            setToastMessage("Comparision Has Been Done Successfully!");
            setLoading(false)
            setShowMessage(true);

        } catch (error) {
            console.error("Error submitting data:", error);
            setToastMessage("Something Went Wrong! Try Later.");
             setLoading(false)
            setShowMessage(true);
        }
    };






    return (
        <>
                <div className="wp_product_checking">
            <div className="wp_product_Header_section">
                <div className="int_heading_content">
                    <h4>Products Comparision</h4>
                    <span className="active_state active">Active</span>
                </div>
                <div className="right_side_header_wp">
                    <div className="intemation">
                        <FaCircleInfo size={15} /> This Tab is temporary & will dissolve after Products Uploading.
                    </div>
                    <CustomBtnLogo
                        image={swapicon}
                        label="Compare"
                        withIcon={true}
                        iconType="import"
                        type="button"
                        style={{
                            padding: "5px 5px",
                            marginRight: "20px"
                        }}
                        onClick={async () => {
                            handleCompareProducts()
                        }}
                    />
                </div>
            </div>

            <div className="wp_content_to_upload">

                <div className="wp_content_upload_sec">
                    <h5>Select Category</h5>
                    <div className="all_categories_wp">
                        <div className="category-list">
                            {categories &&
                                categories.map((category) => (
                                    <div key={category.uid} className="main-category">
                                        <div className="category-item-heading-update">
                                            <div className="category-main">
                                                <input
                                                    type="checkbox"
                                                    disabled={true}
                                                    id={`main-category-${category.uid}`}
                                                    // checked={formData.categories.some(
                                                    //     (cat) => cat.name === category.name
                                                    // )}
                                                    onChange={() => {

                                                    }}
                                                />
                                                <label htmlFor={`main-category-${category.uid}`}>
                                                    {category.name}
                                                </label>
                                            </div>

                                        </div>

                                        {renderSubcategories(category)}
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>


                <div className="wp_content_upload_sec" style={{ marginLeft: "0px" }}>
                    <h5>Upload Products</h5>
                    <div className="upload_csv_file_wp">
                        <div className="dotted_line_wp" onClick={triggerFileInput}>
                            <FaFileCsv style={{ color: "#963a0b" }} size={50} />
                            <p>Upload CSV file</p>
                            <span>Please upload the CSV file according to Selected category.</span>
                            <input
                                type="file"
                                accept=".csv"
                                onChange={handleFileChange}
                                ref={fileInputRef}
                                style={{ display: "none" }} // Hide the input
                            />
                        </div>

                        {csvFile && (
                            <div className="selected_file_wp">
                                {csvFile.name}
                                <IoMdClose
                                    onClick={() => {
                                        setCsvFile(null);
                                        setCsvContent("");
                                        if (fileInputRef.current) {
                                            fileInputRef.current.value = null; // <- This line is crucial
                                        }
                                    }}
                                    className="close_wp"
                                />
                            </div>
                        )}

                    </div>
                </div>
                <div className="wp_content_result_sec">
                    <h5>Results</h5>
                    <div className="results_container_wp">
                        <div className="result_box">
                            <span className="result_box_heading">
                                <h3>WP Total</h3>
                                <h6>Products</h6>
                            </span>
                            <div className="download_icon_wp">
                                <TbFileDownload color="#963a0b" size={30} />
                            </div>
                            <span className="result_box_value">
                                <h3>{resultStats.wp_total}</h3>
                                <h6>Products</h6>
                            </span>
                        </div>
                        <div className="result_box">  <span className="result_box_heading">
                            <h3>React Total</h3>
                            <h6>Products</h6>
                        </span>
                            <div className="download_icon_wp">
                                <TbFileDownload color="#963a0b" size={30} />
                            </div>
                            <span className="result_box_value">
                                <h3>{resultStats.react_total}</h3>
                                <h6>Products</h6>
                            </span></div>
                        <div className="result_box">
                            <span className="result_box_heading">
                                <h3>Un Matched Simple</h3>
                                <h6>Products</h6>
                            </span>
                            <div className="download_icon_wp" onClick={() => { handleExport(simpleArray, "simple", selectedCategory?.name) }}>
                                <TbFileDownload color="#963a0b" size={30} />
                            </div>
                            <span className="result_box_value">
                                <h3>{resultStats.simple}</h3>
                                <h6>Products</h6>
                            </span></div>
                        <div className="result_box">
                            <span className="result_box_heading">
                                <h3>Un Matched Variable</h3>
                                <h6>Products</h6>
                            </span>
                            <div className="download_icon_wp" onClick={() => { handleExport(variationsArray, "variable", selectedCategory?.name) }}>
                                <TbFileDownload color="#963a0b" size={30} />
                            </div>
                            <span className="result_box_value">
                                <h3>{resultStats.variations}</h3>
                                <h6>Products</h6>
                            </span></div>
                    </div>


                </div>
            </div>
            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />
        </div>
        
              {loading && <div className="backdrop">
                <div className="loader-container">
                  <MainLoader heading1={"Comparing..."} />
                </div>
              </div>}
        </>
    )
}